<template>
    <div class="qksm qksm13">
        <h4>十三、国有资产占用情况说明</h4>
        <div class="nogap">
            <p>
                本部门共有车辆<reason type="integer" classname="qksm integer" name="共有车辆" v-model:value="car.共有车辆"></reason>辆，
                其中，副部（省）级及以上领导用车<reason type="integer" classname="qksm integer" name="领导用车" v-model:value="car.领导用车"></reason>辆、
                主要领导干部用车<reason type="integer" classname="qksm integer" name="主要领导用车" v-model:value="car.主要领导用车"></reason>辆、
                机要通信用车<reason type="integer" classname="qksm integer" name="机要通信用车" v-model:value="car.机要通信用车"></reason>辆、
                应急保障用车<reason type="integer" classname="qksm integer" name="应急保障用车" v-model:value="car.应急保障用车"></reason>辆、
                执法执勤用车<reason type="integer" classname="qksm integer" name="执法执勤用车" v-model:value="car.执法执勤用车"></reason>辆、
                特种专业用车<reason type="integer" classname="qksm integer" name="特种专业用车" v-model:value="car.特种专业用车"></reason>辆、
                业务用车<reason type="integer" classname="qksm integer" name="业务用车" v-model:value="car.业务用车"></reason>辆、
                其他用车<reason type="integer" classname="qksm integer" name="其他用车" v-model:value="car.其他用车"></reason>辆
                <span v-if="num(car.其他用车)>0">
                    ，其他用车主要是
                    <reason type="textarea" classname="qksm widest" name="其他用车主要是" v-model:value="qksm['其他用车主要是']"></reason>
                </span>
                <span v-else>；</span>
                单价50万元（含）以上的通用设备<reason type="integer" classname="qksm integer" name="通用设备" v-model:value="qksm['通用设备']"></reason>台（套），
                单价100万元（含）以上的专用设备<reason type="integer" classname="qksm integer" name="专用设备" v-model:value="qksm['专用设备']"></reason>台（套）。
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm13",
        props: {
            T13: {
                type: Object,
                default: "",
            },
            T9: {
                type: Object,
                default: "",
            },
        },
        data() {
            var arr = ["共有车辆", "领导用车", "主要领导用车", "机要通信用车", "应急保障用车", "执法执勤用车", "特种专业用车", "业务用车", "其他用车"]
            var car = [];
            for (var i = 0; i < arr.length; i++) {
                car[arr[i]] = this.pickOneOf(this.$store.state.divData.qksm[arr[i]], this.num(this.T13[arr[i]]))
            }
            if (this.T13) {
                this.$store.state.divData.qksm['通用设备'] = this.pickOneOf(this.$store.state.divData.qksm['通用设备'], this.num(this.T13["通用设备"])) 
                this.$store.state.divData.qksm['专用设备'] = this.pickOneOf(this.$store.state.divData.qksm['专用设备'], this.num(this.T13["专用设备"]))
            }
            return {
                qksm: this.$store.state.divData.qksm,
                car:car,
                isPdf: this.$parent.isPdf
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        methods: {
            inspect() {
                var arr = Object.values(this.car)
                var sum = 0;
                for (var i = 1; i < arr.length; i++) {
                    sum = sum + this.num(arr[i])
                }
                if (this.num(arr[0]).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm13", "请检查本页《十三、国有资产占用情况说》，各项车辆使用情况总和应该等于部门共有车辆总数。");
                } else {
                    this.remove("qksm13")
                }
                /*if (this.num(this.car['共有车辆']) < this.num(this.T9.统计数[1].f)) {
                    this.addOrSet("qksm131", "请检查本页《十三、国有资产占用情况说》，请仔细确认国有资产占用情况车辆数不能小于一般公共预算拨款开支运行维护费的公务用车保有量。");
                } else {
                    this.remove("qksm131")
                }*/
            }
        }, components: {
            reason,
        },
    };
</script>
